module.exports = __webpack_public_path__ + "assets/69d9715f1507014aa532630bdd1559d7.png";